export enum EventCategoryEnum {
    shoppingCart = 'Warenkorb',
    notificationBar = 'Notification',
    accountNavigation = 'Account-Navigation',
    accountDashboard = 'Account-Dashboard',
    accountResidueList = 'Account-Rückstandsliste',
    accountInflow = 'Account-Nächste-Lieferungen',
    accountOrderDetail = 'Account-Auftragsdetail',
    accountOrderList = 'Account-Auftragsübersicht',
    productCustomization = 'Konfigurator',
}
